// extracted by mini-css-extract-plugin
export default {"box":"styles_box__Bhm1q","error":"styles_error__M0Xzu styles_box__Bhm1q","success":"styles_success__DepTK styles_box__Bhm1q"};